import { useCallback, useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import { ff } from '@atlassian/jira-feature-flagging';
import { useCommandPaletteSearch } from '../command-palette';

export const useCommandPaletteSearchDebounced = (
	debounceTime = ff('compal-issue-actions-follow-up-improvements_y49xu') ? 250 : 150,
): [string, (newValue: string) => void] => {
	const [{ search }, { handleSearch }] = useCommandPaletteSearch();

	const [debouncedSearch, setDebouncedSearch] = useState(search);

	const debouncedSetSearch = useMemo(
		() => debounce(setDebouncedSearch, debounceTime),
		[debounceTime],
	);
	useEffect(() => {
		debouncedSetSearch(search);
	}, [debouncedSetSearch, search]);

	useEffect(() => () => debouncedSetSearch.cancel(), [debouncedSetSearch]);

	const setSearch = useCallback(
		(newSearch: string) => {
			debouncedSetSearch.cancel();
			handleSearch(newSearch);
			setDebouncedSearch(newSearch);
		},
		[debouncedSetSearch, handleSearch],
	);

	return useMemo(() => [debouncedSearch, setSearch], [debouncedSearch, setSearch]);
};
